import gql from 'graphql-tag';

export const ABOUT_US_PAGE_PARTNERS_FRAGMENT = gql`
  fragment aboutUsPagePartners on AboutUsPagePartnersType {
    partnersTitle
    partnersText
    id
  }
`;
